import { Component, Renderer2 } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { HeaderPublicComponent } from './components/header/header-public/header-public.component';
import { TranslateService } from '@ngx-translate/core';
import { LoadingSpinnerComponent } from './components/shared/ui/loading-spinner/loading-spinner.component';
import { SpinnerService } from './core/services/spinner.service';
import { DataSessionService } from './core/services/data-session.service';
import { DataLayerService } from './core/services/data-layer.service';
import { HeaderLoggedComponent } from './components/header/header-logged/header-logged.component';
import { FooterComponent } from './components/footer/footer.component';
import { IonContent } from '@ionic/angular/standalone';
import { UserSessionData } from './core/types/session-data';
import { LOCAL_LANG } from './core/constants/constants';

@Component({
  standalone: true,
  imports: [
    IonContent,
    HeaderPublicComponent,
    HeaderLoggedComponent,
    FooterComponent,
    RouterModule,
    LoadingSpinnerComponent,
  ],
  selector: 'app-root',
  providers: [SpinnerService, DataSessionService],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  title: string = 'My Global Risks';
  isLoggedIn: boolean = false;
  userData!: UserSessionData;
  lang: string = 'es';

  constructor(
    private translate: TranslateService,
    private renderer: Renderer2,
    private readonly _dataSessionService: DataSessionService,
    private readonly _dataLayerService: DataLayerService,
    private _activatedRoute: ActivatedRoute,
    private _router: Router
  ) {
    this._dataSessionService.isLoggedIn$.subscribe((status) => {
      this.isLoggedIn = status;

      if (this.isLoggedIn && this._dataSessionService.userData) {
        this.userData = this._dataSessionService.userData;
        this._dataLayerService.loadUserProperties(this.userData);
      } else if (!this.isLoggedIn) {
        this.userData = null as any;
        this._dataLayerService.loadUserProperties(this.userData);
      }
    });
  }

  ngOnInit(): void {
    this._dataLayerService.initDataLayer();
    this._activatedRoute.queryParams.subscribe((params) => {
      const langUrl = params['lang'];
      if (langUrl && ['es', 'pt', 'en'].includes(langUrl)) {
        localStorage.setItem(LOCAL_LANG, langUrl);

        this._router.navigate([], {
          queryParams: { lang: null },
          queryParamsHandling: 'merge',
          replaceUrl: true,
        });

        this._initLang(langUrl);
      }
    });

    this._dataSessionService.run();
    this._dataLayerService.publishUserProperties();
    const lang = localStorage.getItem(LOCAL_LANG);
    this._initLang(lang || this.userData?.lang || 'es');
  }

  _initLang(lang: string): void {
    this.lang = lang;
    this.translate.addLangs(['pt', 'es', 'en']);
    this.translate.setDefaultLang(lang);
    this.translate.use(lang);
    this.renderer.setAttribute(document.documentElement, 'lang', lang);
    this._dataSessionService.loadOneTrustScripts(lang);
    this._dataLayerService.setUserLang(lang);
  }
}
